import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'ordered_prod': {
    title: '产品编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ProductSelect',
      title: '产品编码'
    },
    width: 200
  },
  'description': {
    title: '产品名称',
    type: 'input',
    equation: cusname,
    width: 300
  },
  'short': {
    title: '产品简称',
    type: 'input',
    equation: city,
    width: 160
  },
  'cust_name': {
    title: '开票客户名称',
    type: 'input',
    equation: city,
    width: 200
  },
  'order_customer': {
    title: '经销商家',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '经销商家'
    }
  },
  'order_cust_name': {
    title: '经销商家名称',
    type: 'input',
    equation: city,
    width: 200
  },
  'zzfld000001': {
    describe: true, // 描述 _text 添加属性
    title: '营销单元', // 字段名称
    type: 'select', // 输入类型 下拉
    equation: all, // 条件
    dictionary: 'sale' // 字典 （营销单元(sale)， 基地(base)，省(region)，市(city)，区(street)）
  },
  'zzfld00002s': {
    title: '产品规格',
    type: 'input',
    equation: city,
    width: 200
  },
  'pcate': {
    describe: true,
    title: '产品分类',
    type: 'select',
    equation: city,
    dictionary: 'A0017',
    width: 180
  },
  'chfl': {
    describe: true,
    title: '存货分类',
    type: 'select',
    equation: all,
    dictionary: 'A0019',
    width: 180
  },
  'brand_bq': {
    describe: true,
    title: 'bq分类',
    type: 'select',
    equation: city,
    dictionary: 'A0018'
  },
  'ycate': {
    describe: true,
    title: '月报分类',
    type: 'select',
    equation: city,
    dictionary: 'A0016'
  },
  'brand': {
    describe: true,
    title: '品牌(生产计划)',
    type: 'select',
    equation: city,
    dictionary: 'A0015',
    width: 180
  },
  'begin_datum': {
    title: '经销日期起',
    type: 'date',
    equation: city
  },
  'end_datum': {
    title: '经销日期止',
    type: 'date',
    equation: city
  }
}



// WEBPACK FOOTER //
// ./src/views/report-forms-manage/config/productSellReportForms.js